import crypto from 'crypto';

/** Meta requires SHA-256 over lowercase, trimmed values */
export function sha256(input?: string | null): string | undefined {
  if (!input) return undefined;
  return crypto.createHash("sha256").update(input.trim().toLowerCase()).digest("hex");
}
